module.exports = __webpack_public_path__ + "images/directory/icons/customIcon.3a51aece16ac38fdbc16.png";